// extracted by mini-css-extract-plugin
export default {"tabSelected":"Tab_tabSelected__INACn","content":"Tab_content__1Cux7","text":"Tab_text__FITvH","div":"Tab_div__7iPkl","tabUnselected":"Tab_tabUnselected__1sdJ5"};